import MAYA from '../../../maya_api'
import _ from 'lodash'
import {REPORT_TYPES, REPORT_MODES} from "../../../constants";
import {setLoadingContent} from "../../../layouts/Content/modules/loadingContent";
import moment from "moment";
import {validateEmail} from "../../../helpers";

// ------------------------------------
// Constants
// ------------------------------------

const CHANGE_ACTIVE_HISTORY_PAGE = 'CHANGE_ACTIVE_HISTORY_PAGE';
const CHANGE_REPORT_TYPE = 'CHANGE_REPORT_TYPE';
const CHANGE_REPORT_MODE = 'CHANGE_REPORT_MODE';
const SET_GENARATION_LOADING = 'SET_GENARATION_LOADING';
const LOAD_REPORTS = 'LOAD_REPORTS';
const GENERATE_REPORT = 'GENERATE_REPORT';
const CHANGE_FILTER_DATES = 'CHANGE_FILTER_DATES';
const RESET_FILTER_DATES = 'RESET_FILTER_DATES';
const SWITCH_AUTOMATIC_REPORTS = 'ENABLE_AUTOMATIC_REPORTS';
const CHANGE_DAY_OF_WEEK_IN_AUTOMATIC_REPORT = 'CHANGE_DAY_OF_WEEK_IN_AUTOMATIC_REPORT';
const ADD_ACTIVE_EMAILS_IN_AUTOMATIC_REPORT = 'ADD_ACTIVE_EMAILS_IN_AUTOMATIC_REPORT';
const REMOVE_ACTIVE_EMAILS_IN_AUTOMATIC_REPORT = 'REMOVE_ACTIVE_EMAILS_IN_AUTOMATIC_REPORT';
const CHANGE_EMAIL_INPUT = 'CHANGE_EMAIL_INPUT';
const LOAD_AUTOMATIC_REPORT_CONFIG = 'LOAD_AUTOMATIC_REPORT_CONFIG';
const UPDATE_AUTOMATIC_REPORT_CONFIG = 'UPDATE_AUTOMATIC_REPORT_CONFIG';
const LOAD_DEVICES = 'LOAD_DEVICES';
const UPDATE_DEVICES = 'UPDATE_DEVICES';

function createInitialDatesFilter() {
  return {
    filter_start_date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
    filter_end_date: moment().format('YYYY-MM-DD')
  }
}

function createInitialDataForAutomaticReports() {
  return {
    automatic_daily_enabled: false,
    automatic_days: [],
    automatic_emails: [],
    devices_manual: [],
    devices_automatic: []
  }
}

const initialState = {
  mode: REPORT_MODES.DETAILED,
  type: REPORT_TYPES.DAILY,
  list: [],
  loading: false,
  history_active_page: 1,
  ...createInitialDatesFilter(),
  automatic_email_input: '',
  ...createInitialDataForAutomaticReports(),
  devices: []
};


// ------------------------------------
// Actions
// ------------------------------------

function changeReportMode(value) {
  return {
    type: CHANGE_REPORT_MODE,
    payload: value
  }
}

function changeReportType(value) {
  return {
    type: CHANGE_REPORT_TYPE,
    payload: value
  }
}

function loadReports(){
  return async(dispatch, getStore) => {
    dispatch(setLoadingContent(true));

    const startDate = getStore().reports.filter_start_date;
    const endDate = getStore().reports.filter_end_date;

    const reports = await MAYA.getReports(startDate, endDate);

    dispatch(setLoadingContent(false));

    dispatch({
      type: LOAD_REPORTS,
      payload: reports
    })
  }
}

function setGenerationLoading(value) {
  return {
    type: SET_GENARATION_LOADING,
    payload: value
  }
}

function generateReport(mode, startDate, endDate) {
  return async(dispatch, getStore) => {

    const type = getStore().reports.type;
    const from = startDate && moment(startDate).format('YYYY-MM-DD');
    const to = endDate && moment(endDate).format('YYYY-MM-DD');

    MAYA.generateReport(type, mode, from, to);

    dispatch({
      type: GENERATE_REPORT
    })
  };
}

function changeActiveHistoryPage(value = 1){
  return {
    type: CHANGE_ACTIVE_HISTORY_PAGE,
    payload: value
  }
}

function changeFilterDates(value = {}) {
  return {
    type: CHANGE_FILTER_DATES,
    payload: value
  }
}

function resetFilterDates() {
  return {
    type: RESET_FILTER_DATES
  }
}

function switchAutomaticReport() {
  return (dispatch, getStore) => {
    const automatic_daily_enabled = getStore().reports.automatic_daily_enabled;
    let automaticDays = getStore().reports.automatic_days;

    if(!automatic_daily_enabled && automaticDays.length <= 0){
      automaticDays = [1,2,3,4,5]
    }

    dispatch({
      type: SWITCH_AUTOMATIC_REPORTS,
      payload: {
        automatic_daily_enabled: !automatic_daily_enabled,
        automatic_days: automaticDays
      }
    });

    dispatch(updateAutomaticReportConfig());
  }
}

function changeDayOfWeekOnAutomaticReport(value) {
  return (dispatch, getStore) => {
    let automaticDays = getStore().reports.automatic_days;
    const availableDays = [0,1,2,3,4,5,6];

    if(!_.includes(availableDays, value)){
      console.log('Unavailable value');
      return false;
    }

    const isDayInEnabledDays = _.includes(automaticDays, value);

    if(isDayInEnabledDays){
      automaticDays = _.pull(automaticDays, value)
    } else {
      automaticDays.push(value)
    }

    automaticDays = _.sortBy(automaticDays, (v) => v);

    dispatch({
      type: CHANGE_DAY_OF_WEEK_IN_AUTOMATIC_REPORT,
      payload: automaticDays
    });

    dispatch(updateAutomaticReportConfig());
  }
}

function addAutomaticEmail() {
  return (dispatch, getStore) => {
    let automaticEmails = getStore().reports.automatic_emails;
    const emailInput = getStore().reports.automatic_email_input;

    if(!validateEmail(emailInput)){
      return false;
    }

    if(_.includes(automaticEmails, emailInput)){
      return false;
    }

    automaticEmails.push(emailInput);

    dispatch({
      type: ADD_ACTIVE_EMAILS_IN_AUTOMATIC_REPORT,
      payload: automaticEmails
    });

    dispatch(updateAutomaticReportConfig());
  }
}

function changeReportDevicesManual(device_id) {
  return (dispatch, getStore) => {
    let devices = getStore().reports.devices;

    const updatedDevice = _.find(devices, (d) => d.device_id === device_id);
    updatedDevice.manual_enabled = !updatedDevice.manual_enabled;

    _.remove(devices, (d) => d.device_id === device_id);
    devices.push(updatedDevice);

    dispatch({
      type: UPDATE_DEVICES,
      payload: devices
    });

    dispatch(updateAutomaticReportConfig());
  }
}

function selectAllManualDevices(){
  return (dispatch, getStore) => {
    let devices = getStore().reports.devices;

    _.each(devices, (d) => {
      d.manual_enabled = true;
    });

    dispatch({
      type: UPDATE_DEVICES,
      payload: devices
    });

    dispatch(updateAutomaticReportConfig());
  }
}

function changeReportDevicesAutomatic(device_id) {
  return (dispatch, getStore) => {
    let devices = getStore().reports.devices;

    const updatedDevice = _.find(devices, (d) => d.device_id === device_id);
    updatedDevice.automatic_enabled = !updatedDevice.automatic_enabled;

    _.remove(devices, (d) => d.device_id === device_id);
    devices.push(updatedDevice);

    dispatch({
      type: UPDATE_DEVICES,
      payload: devices
    });

    dispatch(updateAutomaticReportConfig());
  }
}

function selectAllAutomaticDevices(){
  return (dispatch, getStore) => {
    let devices = getStore().reports.devices;

    _.each(devices, (d) => {
      d.automatic_enabled = true;
    });

    dispatch({
      type: UPDATE_DEVICES,
      payload: devices
    });

    dispatch(updateAutomaticReportConfig());
  }
}

function removeAutomaticEmail(value) {
  return (dispatch, getStore) => {
    let automaticEmails = getStore().reports.automatic_emails;
    automaticEmails = _.pull(automaticEmails, value);

    dispatch({
      type: REMOVE_ACTIVE_EMAILS_IN_AUTOMATIC_REPORT,
      payload: automaticEmails
    });

    dispatch(updateAutomaticReportConfig());
  }
}

function changeEmailInput(value = '') {
  return {
    type: CHANGE_EMAIL_INPUT,
    payload: value
  }
}

function loadAutomaticReportConfig() {
  return async(dispatch) => {
    let dafaultPayload = createInitialDataForAutomaticReports();

    const result = await MAYA.getAutomaticReportConfig();

    let payload = {
      automatic_daily_enabled: (result && !_.isUndefined(result.enabled)) ? result.enabled: dafaultPayload.automatic_daily_enabled,
      automatic_days: (result && result.x_data && result.x_data.days_of_the_week) ? result.x_data.days_of_the_week : dafaultPayload.automatic_days,
      automatic_emails: (result && result.x_data && result.x_data.recipient_emails) ? result.x_data.recipient_emails : dafaultPayload.automatic_emails,
      devices_manual: (result && result.x_data && result.x_data.devices_manual) ? result.x_data.devices_manual : dafaultPayload.devices_manual,
      devices_automatic: (result && result.x_data && result.x_data.devices_automatic) ? result.x_data.devices_automatic : dafaultPayload.devices_automatic
    };

    dispatch({
      type: LOAD_AUTOMATIC_REPORT_CONFIG,
      payload: payload
    })
  }
}

function updateAutomaticReportConfig() {
  return async(dispatch, getStore) => {
    const data = getStore().reports;

    let options = {};

    if(data.automatic_days)   options.days_of_the_week = data.automatic_days;
    if(data.automatic_emails) options.recipient_emails = data.automatic_emails;

    if(data.devices){
      options.devices_manual = _.map(_.filter(data.devices, 'manual_enabled'), 'device_id');
      options.devices_automatic = _.map(_.filter(data.devices, 'automatic_enabled'), 'device_id');
    }

    let result = await MAYA.updateAutomaticReportConfig(data.automatic_daily_enabled, options);

    dispatch({
      type: UPDATE_AUTOMATIC_REPORT_CONFIG,
      payload: result
    })
  }
}

function loadDevices(){
  return async(dispatch, getStore) => {
    dispatch(setLoadingContent(true));

    let result = await MAYA.loadReportsDevices() || [];

    dispatch(setLoadingContent(false));

    dispatch({
      type: LOAD_DEVICES,
      payload: result
    })
  }
}

export {
  changeReportMode,
  changeReportType,
  loadReports,
  generateReport,
  setGenerationLoading,
  changeActiveHistoryPage,
  changeFilterDates,
  resetFilterDates,
  switchAutomaticReport,
  changeDayOfWeekOnAutomaticReport,
  addAutomaticEmail,
  removeAutomaticEmail,
  changeEmailInput,
  loadAutomaticReportConfig,
  updateAutomaticReportConfig,
  loadDevices,
  changeReportDevicesManual,
  changeReportDevicesAutomatic,
  selectAllManualDevices,
  selectAllAutomaticDevices
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CHANGE_REPORT_MODE]: (state, action) => ({
    ...state,
    mode: action.payload,
    type: REPORT_TYPES.DAILY
  }),
  [CHANGE_REPORT_TYPE]: (state, action) => ({
    ...state,
    type: action.payload
  }),
  [SET_GENARATION_LOADING]: (state, action) => ({
    ...state,
    loading: action.payload
  }),
  [LOAD_REPORTS]: (state, action) => ({
    ...state,
    list: action.payload
  }),
  [GENERATE_REPORT]: (state, action) => ({
    ...state,
    loading: true
  }),
  [CHANGE_ACTIVE_HISTORY_PAGE]: (state, action) => ({
    ...state,
    history_active_page: action.payload
  }),
  [CHANGE_FILTER_DATES]: (state, action) => ({
    ...state,
    filter_start_date: action.payload.startDate,
    filter_end_date: action.payload.endDate,
    history_active_page: 1
  }),
  [RESET_FILTER_DATES]: (state, action) => ({
    ...state,
    ...createInitialDatesFilter()
  }),
  [SWITCH_AUTOMATIC_REPORTS]: (state, action) => ({
    ...state,
    automatic_daily_enabled: action.payload.automatic_daily_enabled,
    automatic_days: action.payload.automatic_days
  }),
  [CHANGE_DAY_OF_WEEK_IN_AUTOMATIC_REPORT]: (state, action) => ({
    ...state,
    automatic_days: action.payload
  }),
  [ADD_ACTIVE_EMAILS_IN_AUTOMATIC_REPORT]: (state, action) => ({
    ...state,
    automatic_emails: action.payload,
    automatic_email_input: ''
  }),
  [REMOVE_ACTIVE_EMAILS_IN_AUTOMATIC_REPORT]: (state, action) => ({
    ...state,
    automatic_emails: action.payload
  }),
  [CHANGE_EMAIL_INPUT]: (state, action) => ({
    ...state,
    automatic_email_input: action.payload
  }),
  [LOAD_AUTOMATIC_REPORT_CONFIG]: (state, action) => ({
    ...state,
    ...action.payload
  }),
  [UPDATE_AUTOMATIC_REPORT_CONFIG]: (state, action) => ({
    ...state
  }),
  [LOAD_DEVICES]: (state, action) => ({
    ...state,
    devices: action.payload
  }),
  [UPDATE_DEVICES]: (state, action) => ({
    ...state,
    devices: action.payload
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------

export default function reportsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/Reports/modules/reports.js